import * as AccordionModule from './components/ui/accordion/index.js'
import * as AlertModule from './components/ui/alert/index.js'
import * as AlertDialogModule from './components/ui/alert-dialog/index.js'
import * as AspectRatioModule from './components/ui/aspect-ratio/index.js'
import * as AvatarModule from './components/ui/avatar/index.js'
import * as BadgeModule from './components/ui/badge/index.js'
import * as BreadcrumbModule from './components/ui/breadcrumb/index.js'
import * as ButtonModule from './components/ui/button/index.js'
import * as CardModule from './components/ui/card/index.js'
import * as ChartModule from './components/ui/chart/index.js'
import * as CheckboxModule from './components/ui/checkbox/index.js'
import * as CollapsibleModule from './components/ui/collapsible/index.js'
import * as CopyIdModule from './components/ui/copy-id/index.js'
import * as FormatDateModule from './components/ui/format-date/index.js'
import * as ContextMenuModule from './components/ui/context-menu/index.js'
import * as DrawerModule from './components/ui/drawer/index.js'
import * as DropdownMenuModule from './components/ui/dropdown-menu/index.js'
import * as EmptyModule from './components/ui/empty/index.js'
import * as HoverCardModule from './components/ui/hover-card/index.js'
import * as InputModule from './components/ui/input/index.js'
import * as InputOtpModule from './components/ui/input-otp/index.js'
import * as KbdModule from './components/ui/kbd/index.js'
import * as LabelModule from './components/ui/label/index.js'
import * as MenubarModule from './components/ui/menubar/index.js'
import * as NativeSelectModule from './components/ui/native-select/index.js'
import * as NavigationMenuModule from './components/ui/navigation-menu/index.js'
import * as NumberFieldModule from './components/ui/number-field/index.js'
import * as PinInputModule from './components/ui/pin-input/index.js'
import * as PopoverModule from './components/ui/popover/index.js'
import * as ProgressModule from './components/ui/progress/index.js'
import * as RadioGroupModule from './components/ui/radio-group/index.js'
import * as ResizableModule from './components/ui/resizable/index.js'
import * as ScrollAreaModule from './components/ui/scroll-area/index.js'
import * as SelectModule from './components/ui/select/index.js'
import * as SeparatorModule from './components/ui/separator/index.js'
import * as SkeletonModule from './components/ui/skeleton/index.js'
import * as SliderModule from './components/ui/slider/index.js'
import * as SonnerModule from './components/ui/sonner/index.js'
import * as SpinnerModule from './components/ui/spinner/index.js'
import * as StepperModule from './components/ui/stepper/index.js'
import * as SwitchModule from './components/ui/switch/index.js'
import * as TableModule from './components/ui/table/index.js'
import * as TabsModule from './components/ui/tabs/index.js'
import * as TagsInputModule from './components/ui/tags-input/index.js'
import * as TextareaModule from './components/ui/textarea/index.js'
import * as ToggleModule from './components/ui/toggle/index.js'
import * as TooltipModule from './components/ui/tooltip/index.js'
import * as DataTableModule from './components/ui/data-table/index.js'
import * as NavigationModule from './components/ui/navigation/index.js'
import * as StorefrontModule from './components/ui/storefront/index.js'
import * as LegacyModule from './components/legacy/index.js'

export * from './components/ui/data-table/index.js'
export * from './components/ui/navigation/index.js'
export * from './components/ui/storefront/index.js'
export * from './components/legacy/index.js'
export * from './components/ui/accordion/index.js'
export * from './components/ui/alert/index.js'
export * from './components/ui/alert-dialog/index.js'
export * from './components/ui/aspect-ratio/index.js'
export * from './components/ui/avatar/index.js'
export * from './components/ui/badge/index.js'
export * from './components/ui/breadcrumb/index.js'
export * from './components/ui/button/index.js'
export * from './components/ui/card/index.js'
export * from './components/ui/chart/index.js'
export * from './components/ui/checkbox/index.js'
export * from './components/ui/collapsible/index.js'
export * from './components/ui/copy-id/index.js'
export * from './components/ui/format-date/index.js'
export * from './components/ui/context-menu/index.js'
export * from './components/ui/drawer/index.js'
export * from './components/ui/dropdown-menu/index.js'
export * from './components/ui/empty/index.js'
export * from './components/ui/hover-card/index.js'
export * from './components/ui/input/index.js'
export * from './components/ui/input-otp/index.js'
export * from './components/ui/kbd/index.js'
export * from './components/ui/label/index.js'
export * from './components/ui/menubar/index.js'
export * from './components/ui/native-select/index.js'
export * from './components/ui/navigation-menu/index.js'
export * from './components/ui/number-field/index.js'
export * from './components/ui/pin-input/index.js'
export * from './components/ui/popover/index.js'
export * from './components/ui/progress/index.js'
export * from './components/ui/radio-group/index.js'
export * from './components/ui/resizable/index.js'
export * from './components/ui/scroll-area/index.js'
export * from './components/ui/select/index.js'
export * from './components/ui/separator/index.js'
export * from './components/ui/skeleton/index.js'
export * from './components/ui/slider/index.js'
export * from './components/ui/sonner/index.js'
export * from './components/ui/spinner/index.js'
export * from './components/ui/stepper/index.js'
export * from './components/ui/switch/index.js'
export * from './components/ui/table/index.js'
export * from './components/ui/tabs/index.js'
export * from './components/ui/tags-input/index.js'
export * from './components/ui/textarea/index.js'
export * from './components/ui/toggle/index.js'
export * from './components/ui/tooltip/index.js'

const shadcnModules = [
  AccordionModule,
  AlertModule,
  AlertDialogModule,
  AspectRatioModule,
  AvatarModule,
  BadgeModule,
  BreadcrumbModule,
  ButtonModule,
  CardModule,
  ChartModule,
  CheckboxModule,
  CollapsibleModule,
  CopyIdModule,
  FormatDateModule,
  ContextMenuModule,
  DrawerModule,
  DropdownMenuModule,
  EmptyModule,
  HoverCardModule,
  InputModule,
  InputOtpModule,
  KbdModule,
  LabelModule,
  MenubarModule,
  NativeSelectModule,
  NavigationMenuModule,
  NumberFieldModule,
  PinInputModule,
  PopoverModule,
  ProgressModule,
  RadioGroupModule,
  ResizableModule,
  ScrollAreaModule,
  SelectModule,
  SeparatorModule,
  SkeletonModule,
  SliderModule,
  SonnerModule,
  SpinnerModule,
  StepperModule,
  SwitchModule,
  TableModule,
  TabsModule,
  TagsInputModule,
  TextareaModule,
  ToggleModule,
  TooltipModule,
  DataTableModule,
  NavigationModule,
  StorefrontModule,
  LegacyModule,
]

function isPascalCase(name) {
  return /^[A-Z][A-Za-z0-9]*$/.test(name)
}

function isVueComponentLike(value) {
  const t = typeof value
  return t === 'object' || t === 'function'
}

export function installShadcn(app) {
  shadcnModules.forEach((moduleExports) => {
    Object.entries(moduleExports).forEach(([exportName, exportValue]) => {
      if (isPascalCase(exportName) && isVueComponentLike(exportValue)) {
        app.component(exportName, exportValue)
      }
    })
  })
}
